import React, { useContext } from "react";
import { css } from "emotion";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import { AccountSettingsState } from "../../context/AccountSettingsState";

const ChangePassword = () => {
  const { newPassword, setNewPassword } = useContext(AccountSettingsState);

  const handleChange = (e) => {
    setNewPassword(e.target.value);
  };
  return (
    <div className={container}>
      <div className="title">Change Password</div>
      <div className="form">
        {/* <div className="formItem">
          <label>
            <p>CURRENT PASSWORD</p>
            <input type="password" />
          </label>
        </div> */}
        <div className="formItem">
          <label>
            <p>NEW PASSWORD</p>
            <input
              type="password"
              value={newPassword}
              onChange={handleChange}
            />
          </label>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;

const container = css`
  display: flex;
  flex-direction: column;
  padding: ${boxStyles.standardPadding};
  width: 100%;

  p {
    padding: 5px 0;
  }

  .title {
    padding: 0 0 10px 10px;
  }

  .form {
    width: 100%;
  }

  .formItem {
    padding: 0 5px;
    width: 100%;
  }

  label {
    display: flex;
    flex-direction: column;
    color: ${colors.placeholderText};
    font-size: ${textSizes.normal};
    padding: 10px 0;

    input {
      background-color: ${colors.inputBackground};
      padding: 10px;
      border: none;
      border-radius: ${boxStyles.borderRadius};
      color: ${colors.inputTextColor};
      font-size: ${textSizes.normal};
    }
  }
`;
